<template>
      <v-container>
        <!-- types -->
        <v-row>
          <v-col cols="3">
            <el-text-field
              append-icon="mdi-account"
              autocomplete="off"
              name="test test"
              tooltip="test"
              label="test test test"
              type="text"
              required
              :rules="formRule.username"
              v-model="formModel.test"
            />
          </v-col>
          <v-col cols="3">
            <el-text-field
              autocomplete="off"
              name="test"
              label="test"
              type="text"
              required
              :rules="formRule.username"
              v-model="formModel.username"
            />
          </v-col>
          <v-col cols="3">
            <el-time-picker
              autocomplete="off"
              name="test"
              label="test"
              type="text"
              required
              v-model="formModel.username"
            />
          </v-col>
          <v-col cols="3">
            <el-textarea
              autocomplete="off"
              name="test"
              label="test"
              type="text"
              required
              v-model="formModel.test2"
            />
          </v-col>
          <v-col cols="3">
            <el-date-picker
              append-icon="mdi-account"
              autocomplete="off"
              name="test"
              tooltip="test"
              label="test"
              type="text"
              required
              v-model="formModel.test5"
            />
          </v-col>
          <v-col cols="3">
            <el-autocomplete
              append-icon="mdi-account"
              autocomplete="off"
              name="test88"
              tooltip="test"
              label="test88"
              v-model="formModel.test88"
              :items="[
                { text: 'vienas', value: 'vienas' },
                { text: 'du', value: 'du' },
              ]"
            />
          </v-col>
          <v-col cols="3">
            <el-money-field
              append-icon="mdi-account"
              autocomplete="off"
              name="test88"
              tooltip="test"
              label="test88"
              v-model="formModel.test777"
            />
          </v-col>
        </v-row>
        <!-- btns  -->
        <v-row>
          <v-col cols="3">
            <el-button
              title="none"
              outlined
              large
              tile
              @click.native="localLogin"
              :loading="loading"
            />
          </v-col>
          <v-col cols="3">
            <el-button
              large
              color="primary"
              tile
              @click.native="localLogin"
              :loading="loading"
              title="primary"
            />
          </v-col>
          <v-col cols="3">
            <el-button
              large
              color="secondary"
              tile
              @click.native="localLogin"
              :loading="loading"
              title="secondary"
            />
          </v-col>
          <v-col cols="3">
            <el-button
              small
              tile
              outlined
              icon="pridėti"
              @click.native="localLogin"
              :loading="loading"
              title="test2"
            />
            <el-button
              small
              tile
              outlined
              icon="ištrinti"
              @click.native="localLogin"
              :loading="loading"
              title="test2"
            />
            <el-button
              small
              tile
              icon="pirmyn"
              @click.native="localLogin"
              :loading="loading"
              title="test2"
            />
            <el-button
              small
              tile
              icon="atgal"
              @click.native="localLogin"
              :loading="loading"
              title="test2"
            />
          </v-col>
        </v-row>
        <!-- others  -->
        <v-row>
          <v-col cols="3">
            <el-switch label="test" v-model="formModel.test7"> </el-switch>
          </v-col>

          <v-col cols="3">
            <el-checkbox label="test" v-model="formModel.test17"> </el-checkbox>
          </v-col>

          <v-col cols="3">
            <el-radio-group
              label="test"
              :items="[
                { label: 'foo', value: 'foo' },
                { label: 'bar', value: 'bar' },
              ]"
              v-model="formModel.test8"
            >
            </el-radio-group>
          </v-col>
        </v-row>
        <!-- input types -->
        <v-row>
          <v-col cols="3">
            <el-text-field
              append-icon="mdi-account"
              autocomplete="off"
              name="test"
              tooltip="test"
              label="test"
              type="text"
              required
              :rules="formRule.username"
              v-model="formModel.test"
            />
          </v-col>
          <v-col cols="3">
            <el-text-field
              append-icon="mdi-account"
              autocomplete="off"
              name="test"
              tooltip="test"
              label="test"
              type="text"
              required
              readonly
              :rules="formRule.username"
              v-model="formModel.test"
            />
          </v-col>
          <v-col cols="3">
            <el-text-field
              append-icon="mdi-account"
              autocomplete="off"
              name="test"
              tooltip="test"
              label="test"
              type="text"
              required
              disabled
              :rules="formRule.username"
              v-model="formModel.test"
            />
          </v-col>
        </v-row>
      </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'

export default {
  name: 'test',
  mixins: [userRole],
  data() {
    return {
      loading: false,
      formValid: false,
      formRule: {
        username: [(v) => !!v || 'laukas privalomas'],
      },
      formModel: {},
    }
  },
  computed: {
    ...mapGetters(['appSavitarna']),

    prefix() {
      return ''
    },

    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
    isTest() {
      return process.env.VUE_APP_LOCAL === 'test'
    },
    isPreprod() {
      return process.env.VUE_APP_PREPROD === 'true'
    },
    isSavitarna() {
      return this.appSavitarna
    },
    iPasasUrl() {
      return process.env.VUE_APP_IPASAS_URL
    },
  },
  created() {
    let err = {response: {data: {message: null}}}
    err.response.data.message = "key-1";
    this.$root.$emit('DATA_ERROR', err)
  },
  methods: {
    // code
  },
}
</script>

<style lang="scss" scoped></style>
